<template>
    <div class="Bloodoxygen">
        <!-- 血氧解析 -->
        <div class="left">
            <div class="item">
                <p class="title"><i><img src="@/assets/Analysissoftware/HRV/ic_α@2x.png" alt=""></i>血氧波形图</p>
                <div class="chart">
                    <div ref="Realtime" style="width: 100%;height:540px"></div>
                </div>
            </div>
            <div class="bottom">
                <i><img src="@/assets/Analysissoftware/ic_spo2@2x.png" alt=""></i>
                <div class="describe">
                    血氧饱和度：血饱和度是指血液中的氧气。<br>
                    正常范围（动脉血氧饱和度）：95%-98%
                </div>
            </div>
        </div>
        <div class="right">
            <div class="Basicinfor">
                <label class="title">用户基本信息</label>
                <p class="item">部门：{{BloodOxygenInfo.deptName}}</p>
                <p class="item">姓名：{{BloodOxygenInfo.realName}}</p>
                <p class="item">性别：{{BloodOxygenInfo.sex}}</p>
                <p class="item">年龄：{{BloodOxygenInfo.age}}</p>
            </div>

            <div class="Bloodoxygenvalue">
                <p class="title"><i><img src="@/assets/Analysissoftware/ic_004@2x.png" alt=""></i>实时血氧值</p>
                <div class="Bloodoxygenimg">
                    <img src="@/assets/Analysissoftware/ic_spo2_level@2x.png">
                    <div class="schedule_icon">
                        <span :style="{'bottom':BloodOxygenInfo.curSpo2+'%'}">{{BloodOxygenInfo.curSpo2}}%</span>
                    </div>
                </div>
            </div>

        </div>

        <!-- 检测结果 -->
        <el-dialog
            :visible.sync="dialogVisible"
            width="800px"
            title="检测结果"
            :before-close="handleClose">
            <div class="Monitoringresults">
                <p class="text1">你的血氧值：<b>95%</b></p>
                <b class="text2">您的血氧饱和度正常。请继续保持</b>
            </div>
        </el-dialog>

    </div>
</template>
<script>
export default{
    name:'electromechanical',
    data() {
        return {
            dialogVisible:false,
            BloodOxygenInfo:{},
            userId:JSON.parse(sessionStorage.getItem('xinxi')).UserID,
            time:null
        }
    },
    created(){
        this.getBloodOxygenInfo();
    },
    mounted() {
        var _this=this;
        setTimeout(() => {
            _this.time=setInterval(() => {
                _this.getBloodOxygenInfo();
            }, 1000);
        }, 2000);
        
    },
    methods: {
        getBloodOxygenInfo(){
            this.$Http_Post('bioassay/soft/getBloodOxygenInfo',{userId:this.userId}).then(res=>{
                if(res.Code==0){
                    this.BloodOxygenInfo=res.Data;
                    this.spO2s(res.Data.spO2s);
                }else{
                    this.$message.error(res.Message);
                }
            });
        },
        handleClose(){
            this.dialogVisible=false;
        },
        spO2s(data){
            var Xdata=[];
            for(let item in data){
                Xdata.push(item);
            }
            var myChart = this.$echarts.init(this.$refs.Realtime);
            var option = {
                tooltip: {},
                grid: {
                    top:30,
                    left: 30,  
                    right: 30,
                    bottom:30
                },  
                xAxis: {
                    type: 'category',
                    data:Xdata,
                    axisLine: {lineStyle: {color: '#fff'}},
                },
                yAxis: {
                    type: 'value',
                    max: 110, // 最大值  
                    min:80, // 最小值  
                    interval:5, // 间隔
                    axisLine: {lineStyle: {color: '#fff'}},
                },
                series:[
                {
                    name:'血氧值',
                    data: data,
                    type: 'line',
                    smooth: true,
                    color: '#1FA1CC'  
            
                }
                ]
            };

            myChart.setOption(option);
            window.addEventListener("resize", function () {
                myChart.resize();
            });
        }
    },
    destroyed(){
        clearInterval(this.time);
    }
}
</script>
<style>
.Bloodoxygen img{width: 100%;display:block;}
.Bloodoxygen{background:#291713;display: flex;min-height: 100%;padding: 15px;}
.Bloodoxygen .left{flex: auto;margin-right: 10px;}
.Bloodoxygen .left .item{background: #3F5261;margin: 0 0 10px;}
.Bloodoxygen .left .item .title{background: #1F3E8C;color:#fff;font-size: 20px;display: flex;padding: 5px 10px;}
.Bloodoxygen .left .item .title i{width:30px;display: inline-block;margin-right: 5px;}
.Bloodoxygen .left .item .chart{background: #372C26;}
.Bloodoxygen .left .bottom{background: #48660C;margin: 10px 0 0 ;padding: 40px;display: flex;align-items: center;}
.Bloodoxygen .left .bottom i{width:60px;display: inline-block;margin-right: 10px;}
.Bloodoxygen .left .bottom .describe{color: #fff;display: inline-block;font-size: 24px;}
.Bloodoxygen .right{width:240px;display: inline-block;}
.Bloodoxygen .right .Basicinfor{background:url("../../../assets/Analysissoftware/bg_personal@2x.png") no-repeat;height:360px;background-size: 100% 100%;width: 240px;}
.Bloodoxygen .right .Basicinfor .title{font-size: 22px;color: #fff;display: block;text-align: right;padding:5px 20px 20px 0;}
.Bloodoxygen .right .Basicinfor .item{font-size: 18px;color: #43B8D9;padding: 15px 0 0 20px;}
.Bloodoxygen .right .startBtn{width: 100%;margin: 10px 0;}
.Bloodoxygen .right .Bloodoxygenvalue{background: rgba(255, 255, 255, 0.05);margin: 10px 0 0;padding-bottom: 25px;}
.Bloodoxygen .right .Bloodoxygenvalue .title{background: #008077;color:#fff;font-size: 20px;display: flex;padding: 5px 10px;margin-bottom: 30px;}
.Bloodoxygen .right .Bloodoxygenvalue .title i{width:30px;display: inline-block;margin-right: 5px;}
.Bloodoxygen .right .Bloodoxygenvalue .Bloodoxygenimg{position: relative;width: 96px;padding: 10px 20px;}
.Bloodoxygen .right .Bloodoxygenvalue .Bloodoxygenimg .schedule_icon{height:170px;position: absolute;right: -90px;z-index: 2;bottom: 0;width: 100px;}
.Bloodoxygen .right .Bloodoxygenvalue .Bloodoxygenimg span{font-size: 40px;color: #008077;position: absolute;right:0;bottom: 60%;}
.Bloodoxygen .right .Bloodoxygenvalue .Bloodoxygenimg span::before{content: '';position: absolute;top: 15px;left: -30px;width: 0;height: 0;border-right: 20px solid #008077;border-bottom: 10px solid transparent;border-top: 10px solid transparent;}
.Bloodoxygen .el-dialog__header{background: #008077;text-align: center;}
.Bloodoxygen .el-dialog__title,.Bloodoxygen .el-dialog__close{color: #fff;}
.Bloodoxygen .Monitoringresults{margin: 30px 40px;}
.Bloodoxygen .Monitoringresults .text1{font-size: 30px;color: #24AD5B;}
.Bloodoxygen .Monitoringresults .text1 b{font-size: 36px;}
.Bloodoxygen .Monitoringresults .text2{color: #24AD5B;font-size: 30px;}
</style>